import { api } from '../lib/api'

export type ReportRow = {
  readonly id: number
  readonly created_at: string
  readonly type: string | null
  readonly download_path: string
}

export type ReportsTemplateRef = {
  readonly id: number
  readonly name: string | null
}

export type ReportsIndex = {
  readonly patient: { readonly id: string; readonly name: string | null }
  readonly reports: readonly ReportRow[]
  readonly reports_templates: readonly ReportsTemplateRef[]
}

export type NewReport = {
  readonly patient: { readonly id: string; readonly name: string | null }
  readonly reports_template: { readonly id: number; readonly name: string | null; readonly html_form: string }
  readonly autofill: Readonly<Record<string, string>>
}

function reportsPath(healthCenterId: number, patientId: string): string {
  return `/health_centers/${healthCenterId}/patients/${patientId}/reports`
}

export function fetchReports(healthCenterId: number, patientId: string): Promise<ReportsIndex> {
  return api.get<ReportsIndex>(`${reportsPath(healthCenterId, patientId)}.json`)
}

export function fetchNewReport(healthCenterId: number, patientId: string, reportTemplateId: string): Promise<NewReport> {
  return api.get<NewReport>(`${reportsPath(healthCenterId, patientId)}/new.json?report_template=${reportTemplateId}`)
}

export function createReport(healthCenterId: number, patientId: string, form: FormData): Promise<{ redirect: string }> {
  return api.post<{ redirect: string }>(`${reportsPath(healthCenterId, patientId)}.json`, form)
}
